var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LabelDiagonallyCrossedOut',{staticClass:"price-old-value"},[_c('PriceValue',{attrs:{"value":_vm.value,"bem-modifiers":['price-old-value' ].concat( _vm.bemModifiers)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }